import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { RouteReasonMap } from "@/utils/enum";

const { Tooltip, Tag } = require("antd");

const HardRouteTag = ({ hardRouteLocation }) => {
  return (
    <Tooltip color="#fff" title={RouteReasonMap[hardRouteLocation]}>
      <Tag color="warning">
        <InfoCircleOutlined /> Hard Route
      </Tag>
    </Tooltip>
  );
};

export default HardRouteTag;
